/**
 * Legal / A2P SMS compliance configuration for trplin.
 * Operated by Quen Technologies.
 */
export const legalConfig = {
  brandName: 'trplin',
  websiteUrl: 'https://trplin.com',
  privacyPolicyPath: '/privacy-policy',
  termsPath: '/terms',
  privacyPolicyUrl: 'https://trplin.com/privacy-policy',
  termsUrl: 'https://trplin.com/terms',

  legalEntityName: 'Quen Technologies',
  businessAddress: '4th Floor, N7-401, Paras Irene, Sector 70A Road, Gurugram, Haryana',
  supportEmail: 'contact@quentechnologies.com',

  /** Bump when SMS consent language or SMS policy materially changes. */
  smsConsentVersion: '2026-08-26',
  /** Matches server default OTP_EXPIRY_MINUTES. */
  otpExpiryMinutes: 10,
  effectiveDate: 'August 26, 2026',
  effectiveDateIso: '2026-08-26',
} as const;

export type SmsConsentSource =
  | 'web_phone_auth'
  | 'web_auth_modal'
  | 'web_otp_resend'
  /** Attaching a phone to an account the user is already signed in with. */
  | 'web_link_phone';
